export default __webpack_public_path__ + "static/BG1-3512448f89fb0293138b698c9786bc42.png";